'use client';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import { ResponsiveImage } from '@web/molecules';
import dogLookingInBox from '../../images/dog-in-box-empty.png';
import feedTheObsession from '../../images/feed-the-obesession-animation.svg';
import { useReporter } from '../../reporter';
import { Container, ImageContainer, Headline, Subheadline } from './styles.js';
import { ruffTimeView, userViewsLoadingScreen } from './events';

export const LoadingView = ({
  variant = 'default',
  onClick,
  petName = null,
  eventVariationId = '',
}) => {
  const variantMap = {
    default: {
      image: {
        src: feedTheObsession.src,
        alt: 'ollie logo',
        width: feedTheObsession.width,
        height: feedTheObsession.height,
      },
      headline: 'Loading',
    },
    initial: {
      image: undefined,
      headline: '',
    },
    cro: {
      image: {
        src: feedTheObsession.src,
        alt: 'ollie logo',
        width: feedTheObsession.width,
        height: feedTheObsession.height,
      },
      headline: 'Loading',
    },
    checkout: {
      image: {
        src: feedTheObsession.src,
        alt: 'ollie logo',
        width: feedTheObsession.width,
        height: feedTheObsession.height,
      },
      headline: 'Preparing for checkout',
    },
    deletePet: {
      image: {
        src: feedTheObsession.src,
        alt: 'Dog wagging tail',
        width: feedTheObsession.width,
        height: feedTheObsession.height,
      },
      headline: `Removing ${petName ?? 'pet'} from your cart`,
    },
    failed: {
      image: {
        src: dogLookingInBox.src,
        alt: 'Dog looking in box',
        width: dogLookingInBox.width,
        height: dogLookingInBox.height,
      },
      headline: "Uh oh! We're havin' a ruff time...",
      subHeadline: "Sit tight, we'll figure this out as soon as we can!",
      cta: 'Try again',
    },
  };
  const reporter = useReporter();

  useEffect(() => {
    if (variant === 'failed') {
      reporter.tag(ruffTimeView());
    }
    if (variant === 'cro') {
      reporter.tag(userViewsLoadingScreen(eventVariationId));
    }
  }, [reporter, variant, eventVariationId]);
  return (
    <Container $variant={variant}>
      <ImageContainer>
        {variantMap[variant].image && (
          <ResponsiveImage
            src={variantMap[variant].image.src}
            alt={variantMap[variant].image.alt}
            width={variantMap[variant].image.width}
            height={variantMap[variant].image.height}
          />
        )}
      </ImageContainer>
      <Headline>{variantMap[variant].headline}</Headline>
      {variantMap[variant].subHeadline && (
        <Subheadline $variant={variant}>
          {variantMap[variant].subHeadline}
        </Subheadline>
      )}
      {variantMap[variant].cta && (
        <Button onClick={onClick}>{variantMap[variant].cta}</Button>
      )}
    </Container>
  );
};

LoadingView.displayName = 'LoadingView';

LoadingView.propTypes = {
  variant: PropTypes.oneOf([
    'default',
    'failed',
    'deletePet',
    'cro',
    'checkout',
  ]),
  onClick: PropTypes.func,
  eventVariationId: PropTypes.string,
};
